import {useQuery} from 'react-query';
import request from '../../axios';

interface IFactorDetail {
  جزییات: string[] | string;
  امتیاز: number;
}

type ILoanScoreFactoresResponse = Record<string, IFactorDetail>;

export const getLoanScoreFactores = async (loanGuid?: string) => {
  const {data}: {data: ILoanScoreFactoresResponse} = await request.get(
    'api/v2/payment/farm-validation/report/loan-request/' + loanGuid,
  );
  return data;
};

const useGetLoanScoreFactores = (loanGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['loan-score-factores'],
    queryFn: () => getLoanScoreFactores(loanGuid),
    enabled: Boolean(loanGuid),
  });
  return {data, isLoading};
};

export default useGetLoanScoreFactores;
